import { render, staticRenderFns } from "./ChapterConfiguratorManagers.vue?vue&type=template&id=961fb7f0&"
import script from "./ChapterConfiguratorManagers.vue?vue&type=script&lang=js&"
export * from "./ChapterConfiguratorManagers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports